import {XauditModel} from '../../../models/xaudit.model';

export class TreatmentEndoAnesthesiaDataModel extends XauditModel {
  AnesthesiaID: string;
  PatientId: string;
  CaseWorkItemToothId: string;
  AnesthesiaDate: string;
  enumAnestQuantityID: string;
  enumAnestTypeID: string;
  enumAnestAnesthesiaID: string;
  AnesthesiaExpDate: string;
  AnesthesiaBatch: string;
  isN2O: boolean;
  N2OxN2OTimeOn: string;
  N2OxN2OTimeOff: string;
  N2OxO2TimeOn: string;
  N2OxO2TimeOff: string;
  N2OxPctN2O: number;
  N2OxMixLpMxN2O: string;
  N2OxMixLpMxO2: string;
}
